import { getCategoryByName } from '@oxappsec/ox-consolidated-categories';
import { FC, useCallback } from 'react';
import { AppPages, navigate } from '../../../common/routing/app-navigator';
import { setCategoryFilter } from '../../active-issues/actions/filter-issues-actions';
import BaseIssuesTable from '../../common/components/IssuesTable/BaseIssuesTable';
import { useIssuesTableHeader } from '../../common/hooks/use-issues-table-header';
import { Issue } from '../../common/types/issues-types';

const TopIssuesTable: FC<React.PropsWithChildren<TopIssuesTableProps>> = ({
  issues,
  category,
}) => {
  const columns = useIssuesTableHeader({ withMenu: false });
  const handleClick = useCallback(
    (clickedIssue: Issue) => {
      navigate(AppPages.Issues, `?issueId=${clickedIssue.issueId}`);
      if (category) {
        setCategoryFilter(getCategoryByName(clickedIssue.category).id);
      }
    },
    [category],
  );

  return (
    <BaseIssuesTable
      columns={columns}
      rows={issues}
      enableVirtualization={false}
      onRowClick={handleClick}
    />
  );
};

export interface TopIssuesTableProps {
  issues: Issue[];
  category: string;
  tableClassName: string;
}

export default TopIssuesTable;
